import { CaretLeftOutlined } from "@ant-design/icons";
import { Box } from "@chakra-ui/react";
import { Button, Divider, Space } from "antd";
import useMobileMessages from "pages/customer/mobile/useMobileMessages";
import { FC, PropsWithChildren, useCallback } from "react";
import { Outlet } from "react-router-dom";

const InAppLayout: FC<PropsWithChildren> = ({ children }) => {
    const { actionCancelled, appSource } = useMobileMessages();

    const cancelAction = useCallback(() => {
        actionCancelled();
    }, [actionCancelled]);

    return <Box
        px={{ base: 5, md: 15 }}
        py={3}
        width="100%"
    >
        <Space direction="vertical" style={{ width: '100%' }}>
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                backgroundColor: 'var(--dcs-white)',
                paddingTop: '18px',
                boxShadow: '0 5px 5px rgba(182, 182, 182, 0.75)'
            }}>
                <Button block type="link" icon={<CaretLeftOutlined />} onClick={cancelAction}>
                    Return To {appSource}
                </Button>
                <Divider style={{ margin: '18px 18px 0 18px' }} />
            </div>
            <div style={{ marginTop: '18px' }}>
                {children ? children : <Outlet />}
            </div>
        </Space>
    </Box>;
};

export default InAppLayout;